import React from 'react'
import classNames from 'classnames'
import { node, oneOfType, string, object, array } from 'prop-types'

const Header = ({ children, className }) => (
  <thead className={classNames('sw-table-header', 'bg-cloudWhite', className)}>
    <tr>{children}</tr>
  </thead>
)

Header.displayName = 'Header'

Header.propTypes = {
  /** Component's children */
  children: node,
  /** Custom className */
  className: oneOfType([string, object, array])
}

export default Header
